export default __webpack_public_path__ + "static/media/languageIcon.b1e49e32.svg";